
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kaupungit",
      function () {
        return require("private-next-pages/kaupungit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kaupungit"])
      });
    }
  